"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("../types");

var visor_1 = require("../visor");

function getDrawArea(drawable) {
  if (drawable instanceof HTMLElement) {
    return drawable;
  } else if (types_1.isSurface(drawable)) {
    return drawable.drawArea;
  } else if (types_1.isSurfaceInfo(drawable)) {
    var surface = visor_1.visor().surface({
      name: drawable.name,
      tab: drawable.tab,
      styles: drawable.styles
    });
    return surface.drawArea;
  } else {
    throw new Error('Not a drawable');
  }
}

exports.getDrawArea = getDrawArea;

function shallowEquals(a, b) {
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  if (aProps.length !== bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var prop = aProps[i];

    if (a[prop] !== b[prop]) {
      return false;
    }
  }

  return true;
}

exports.shallowEquals = shallowEquals;

function nextFrame() {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (r) {
              return requestAnimationFrame(r);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.nextFrame = nextFrame;